import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getChooseCampaignSearch } from 'modules/experiments/ducks/selectors';
import { refetchCampaigns, setChooseCampaignSearch } from 'modules/experiments/ducks/actions';
import { useDebouncedEffect } from 'utils/hooks/useDebouncedEffect';
import { SearchText } from 'modules/experiments/components/pages/index/sections/facet/Styled';
import { SEARCH_TEXT_INPUT_DEBOUNCE_TIMEOUT_MS } from 'modules/experiments/constants';

import { SearchWrapper } from './styled';

export const ChooseCampaignSearch = () => {
  const dispatch = useDispatch();

  const search = useSelector(getChooseCampaignSearch);
  const [localSearch, setLocalSearch] = useState(search);

  const setSearch = (newSearch: string) => {
    dispatch(setChooseCampaignSearch(newSearch));
    dispatch(refetchCampaigns());
  };

  /**
   * Debouncing the search input. So, that we don't keep querying
   * the backend for every input change.
   */
  useDebouncedEffect(
    () => {
      setSearch(localSearch);
    },
    [localSearch],
    {
      skipEffectOnMount: true,
      debounceTimeout: SEARCH_TEXT_INPUT_DEBOUNCE_TIMEOUT_MS,
    },
  );

  return (
    <SearchWrapper>
      <SearchText
        id="choose-campaign-search"
        data-test="choose-campaign-search-wrapper"
        placeholder={'Search by name or ID'}
        onChange={setLocalSearch}
        value={localSearch}
      />
    </SearchWrapper>
  );
};
